import React, {  } from 'react';
import FestivaliBlock from '../../components/FestivaliBlock';
import PageLayout from '../../components/PageLayout';

export default function FederationadministratorEventsFestivali(props) {
    // const context = React.useMemo(() => ({
    //     mix: (item) => {
    //         return {
    //             organizatorFederatsiyaID: 1, // Организатор федерация
    //         }
    //     }
    // }), [])

    return (
        <PageLayout>
        <FestivaliBlock auth={props.auth} source={"/api/festivali/list/fed"}
                base="federation-administrator" 
                sourceKey="fed"
                create={true}
                ctx={{organizatorFederatsiyaID: 1}}
            />
            </PageLayout>
    );
}
